import { createApp } from 'vue'
import App from './App.vue'
import { vCan } from './auth/directives/vCan'
import i18n from './i18n'
import router from './router'
import pinia from './stores'
import { useAuthStore } from './stores/auth.store'
import './styles/main.css'

const app = createApp(App)

app.use(pinia)
// NOTE: router is intentionally installed AFTER bootstrap() resolves below.
// app.use(router) triggers the initial navigation immediately (microtasks),
// so if it were installed here, the auth guard would run before /auth/me
// returns and would always redirect to login on hard reload.
app.use(i18n)
app.directive('can', vCan)

// Global Vue error handler — last line of defense for render/setup errors
// that escape ErrorBoundary (e.g. errors in async setup of root components).
app.config.errorHandler = (err, _instance, info) => {
  console.error('[Vue]', info, err)
}

// Browser-level fallbacks for unhandled rejections / errors outside Vue's tree.
window.addEventListener('unhandledrejection', (event) => {
  console.error('[unhandledrejection]', event.reason)
})
window.addEventListener('error', (event) => {
  console.error('[window.error]', event.message, event.error)
})

// Resolve the current user via the HttpOnly cookie before mounting so that
// route guards have correct auth state on first navigation.
const auth = useAuthStore(pinia)
auth.bootstrap().finally(() => {
  // Install router here so the initial navigation (and its guards) runs only
  // after auth state has been resolved from the server.
  app.use(router)
  app.mount('#app')
})
